// =============================================================================
// src/features/analytics/analytics-insights-data.ts - Barrel da edicao dos
// Cards de Inteligencia Tatica + derivacao da tabela "Prioridade da edicao".
// Proveniencia: Diario_Anexo-CardsTaticos_2026-07-25.md (2026-07-27); split
// por bloco A-D para respeitar o limite de 500 linhas por arquivo.
// =============================================================================

import { ANALYTICS_INSIGHTS_BLOCK_A } from './analytics-insights-block-a-data';
import { ANALYTICS_INSIGHTS_BLOCK_B } from './analytics-insights-block-b-data';
import { ANALYTICS_INSIGHTS_BLOCK_C } from './analytics-insights-block-c-data';
import { ANALYTICS_INSIGHTS_BLOCK_D } from './analytics-insights-block-d-data';
import { ANALYTICS_INSIGHTS_EDITION } from './analytics-insights-edition-data';
import type {
  AnalyticsInsightBlock,
  AnalyticsInsightCard,
  AnalyticsInsightEditionDoc,
  AnalyticsInsightPriorityRow,
} from './analytics-insights-types';

export { ANALYTICS_INSIGHTS_EDITION } from './analytics-insights-edition-data';

/** Blocos na ordem fixa do documento (A -> D; D e sempre o ultimo). */
export const ANALYTICS_INSIGHTS_BLOCKS: readonly AnalyticsInsightBlock[] = [
  ANALYTICS_INSIGHTS_BLOCK_A,
  ANALYTICS_INSIGHTS_BLOCK_B,
  ANALYTICS_INSIGHTS_BLOCK_C,
  ANALYTICS_INSIGHTS_BLOCK_D,
];

/** Todos os cards na ordem de leitura do documento (01..10). */
export function analyticsInsightsAllCards(): readonly AnalyticsInsightCard[] {
  return ANALYTICS_INSIGHTS_BLOCKS.flatMap((insightBlock) => insightBlock.blockCards);
}

/** Documento estatico completo — fallback do padrao override ?? mock quando o
 * Hasura (edicoes vivas) esta fora; e o default do markup parametrizado. */
export function analyticsInsightsStaticEditionDoc(): AnalyticsInsightEditionDoc {
  return { edition: ANALYTICS_INSIGHTS_EDITION, blocks: ANALYTICS_INSIGHTS_BLOCKS };
}

/** Tabela "Prioridade da edicao" DERIVADA dos cards de QUALQUER edicao:
 * impacto decrescente com desempate por numero do card — reproduz exatamente a
 * ordem publicada nas duas edicoes reais verificadas (25/07 e 27/07). */
export function analyticsInsightPriorityRowsForBlocks(
  editionBlocks: readonly AnalyticsInsightBlock[],
): readonly AnalyticsInsightPriorityRow[] {
  const orderedCards = editionBlocks
    .flatMap((insightBlock) => insightBlock.blockCards)
    .sort(
      (firstCard, secondCard) =>
        secondCard.impactScore - firstCard.impactScore || firstCard.cardNumber - secondCard.cardNumber,
    );
  return orderedCards.map((insightCard) => ({
    impactScore: insightCard.impactScore,
    cardNumber: insightCard.cardNumber,
    priorityTitle: insightCard.priorityTitle,
    classificationLabel: insightCard.classificationLabel,
  }));
}

/** Prioridade da edicao ESTATICA (02, 03, 01, 04, 06, 07, 08, 10, 05, 09). */
export function analyticsInsightsPriorityRows(): readonly AnalyticsInsightPriorityRow[] {
  return analyticsInsightPriorityRowsForBlocks(ANALYTICS_INSIGHTS_BLOCKS);
}
